import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestBase } from './request-base';

export interface KIChatMessageDto {
    role: 'user' | 'assistant' | 'system';
    content: string;
    // Assistant reply time in ms; persisted so reloaded transcripts keep their timing.
    elapsedMs?: number;
}

export interface KISessionMeta {
    SID?: string;
    Name?: string;
    KIDefinitionId?: string;
    ModelName?: string;
    SystemPrompt?: string;
    UserId?: string;
    CreatedAt?: string;
    UpdatedAt?: string;
}

export interface KISession extends KISessionMeta {
    Messages?: KIChatMessageDto[];
}

@Injectable()
export class KISessionService extends RequestBase {
    BasePath = 'api/kisession';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    GetSessions(): Observable<KISessionMeta[]> {
        return this.http.get<KISessionMeta[]>(this.API_BASE_URL + this.BasePath + '/GetSessions', this.options);
    }

    LoadSession(id: string): Observable<KISession> {
        return this.http.get<KISession>(this.API_BASE_URL + this.BasePath + '/LoadSession?id=' + encodeURIComponent(id), this.options);
    }

    SaveSession(session: KISession): Observable<KISession> {
        return this.http.post<KISession>(this.API_BASE_URL + this.BasePath + '/SaveSession', session, this.options);
    }

    AddMessage(id: string, message: KIChatMessageDto): Observable<any> {
        return this.http.post<any>(this.API_BASE_URL + this.BasePath + '/AddMessage?id=' + encodeURIComponent(id), message, this.options);
    }

    DeleteSession(id: string): Observable<any> {
        return this.http.delete<any>(this.API_BASE_URL + this.BasePath + '/DeleteSession?id=' + encodeURIComponent(id), this.options);
    }
}
